export default __webpack_public_path__ + "static/media/7SG16.59e98ffe.jpg";